/**
 * Format a date for the local timezone.
 * @param date The date.
 * @returns The formatted date.
 */
export function formatDate(date) {
    if (typeof date === "number" || typeof date === "bigint") {
        return formatDate(new Date(parseInt(date.toString())));
    }
    if (typeof date === "string") {
        return formatDate(Date.parse(date));
    }
    return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + (date.getDate() + 1);
}
/**
 * Format a date and time for the local timezone.
 * @param date The date.
 * @returns The formatted date and time.
 */
export function formatDateTime(date) {
    if (typeof date === "number" || typeof date === "bigint") {
        return formatDateTime(new Date(parseInt(date.toString())));
    }
    if (typeof date === "string") {
        return formatDateTime(Date.parse(date));
    }
    return date.getFullYear()
        + "-"
        + (date.getMonth() + 1).toString().padStart(2, "0")
        + "-" + date.getDate().toString().padStart(2, "0")
        + " "
        + (date.getHours() % 12 > 0 ? date.getHours() % 12 : 12).toString().padStart(2, "0")
        + ":"
        + date.getMinutes().toString().padStart(2, "0") + (date.getHours() >= 12 ? "pm" : "am");
}
